const FormError = ({ errors, errorKey } = {}) => {
  if (!errors || !errorKey || !errors?.[errorKey]) return null;

  return (
    <ul>
      {errors[errorKey].map((error) => (
        <li className="text-red-600 text-sm" key={`form-error-${errorKey}`}>
          &bull; {error}
        </li>
      ))}
    </ul>
  );
};

export default FormError;
